var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloseConfirm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icons_System_ic_close_background",
    "data-name": "Icons / System / ic_close background",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M19.146,19.854,10,10.705.853,19.852a.5.5,0,0,1-.706-.707L9.292,10,.148.853A.5.5,0,0,1,.856.146L10,9.291,19.144.146a.5.5,0,0,1,.706.707L10.706,10l9.148,9.149a.5.5,0,0,1-.707.706Z",
    transform: "translate(2.001 2.001)",
    fill: "#444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseConfirm);
export default __webpack_public_path__ + "static/media/ic_close_confirm.f5798a2d18992ae9141fb970a7174c22.svg";
export { ForwardRef as ReactComponent };